var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIntermediate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 35.076,
    height: 35.076,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_intermediate",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(336.295 222.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180-2",
    "data-name": "Group 180",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21741",
    "data-name": "Path 21741",
    d: "M16.363,32.182A15.819,15.819,0,1,1,32.184,16.361,15.838,15.838,0,0,1,16.363,32.182",
    transform: "translate(1.175 1.177)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21742",
    "data-name": "Path 21742",
    d: "M2.678,18.5a15.805,15.805,0,0,1,25.8-12.257A15.81,15.81,0,1,0,6.238,28.481,15.737,15.737,0,0,1,2.678,18.5",
    transform: "translate(0.874 0.874)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21743",
    "data-name": "Path 21743",
    d: "M1.957,5.807v.862a11.338,11.338,0,0,0,22.677,0V5.807ZM13.3,16.287a9.631,9.631,0,0,1-9.58-8.76H22.879a9.636,9.636,0,0,1-9.583,8.76",
    transform: "translate(4.243 12.59)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21744",
    "data-name": "Path 21744",
    d: "M17.538,0A17.538,17.538,0,1,0,35.076,17.538,17.558,17.558,0,0,0,17.538,0m0,33.359A15.819,15.819,0,1,1,33.359,17.538,15.84,15.84,0,0,1,17.538,33.359",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21745",
    "data-name": "Path 21745",
    d: "M2.96,8.019a.857.857,0,0,0,.859-.859,2.481,2.481,0,0,1,4.961,0,.86.86,0,0,0,1.72,0,4.2,4.2,0,1,0-8.4,0,.857.857,0,0,0,.859.859",
    transform: "translate(4.555 6.417)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21746",
    "data-name": "Path 21746",
    d: "M7.225,8.019a.857.857,0,0,0,.859-.859,2.481,2.481,0,0,1,4.961,0,.86.86,0,0,0,1.72,0,4.2,4.2,0,1,0-8.4,0,.857.857,0,0,0,.859.859",
    transform: "translate(13.802 6.417)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21747",
    "data-name": "Path 21747",
    d: "M12.094,15.11A9.636,9.636,0,0,1,2.511,6.35H21.677a9.636,9.636,0,0,1-9.583,8.76",
    transform: "translate(5.444 13.767)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIntermediate);
export default __webpack_public_path__ + "static/media/ic_intermediate.2bbc30fa6a0a1eef55517b72e923eb6d.svg";
export { ForwardRef as ReactComponent };